import React from "react";
import { Button } from "components/common";
import { modalBGColor } from "utils/customStyles";
import SuccessMessage from "components/Popups/Messages/SuccessMessage";
import OptionButton from "components/common/Dropdown/OptionButton";

const UpdateUserDetailsModal = ({
  label,
  currentValue,
  onSubmit,
  updateNewValue,
  errorMessage,
  setErrorMessage,
  loading,
  successMainMessage,
  successSubMessage,
  showSuccessState,
  optionButtonText,
  optionButtonNewValue,
  optionButtonUpdateNewValue,
  onKeyDownValidation
}) => {
  const WIDTH384 = { width: "384px" };
  const WIDTHANDBORDER = { width: "384px", border: "1px solid #e2e8f0" };

  return (
    <div style={modalBGColor} className="py-8 px-12">
      {!showSuccessState ? (
        <div
          style={{ width: "434px", height: "365px" }}
          className="flex flex-col justify-center items-center"
        >
          <div style={WIDTH384} className="text-2xl w-96">
            {`Current ${label}`}
          </div>
          <div
            style={WIDTHANDBORDER}
            className="bg-white h-12 flex items-center text-2xl mb-4"
          >
            {currentValue}
          </div>
          <div style={WIDTH384} className="text-2xl">
            {`New ${label}`}
          </div>
          <input
            className="bg-white h-12 flex items-center text-2xl"
            style={WIDTHANDBORDER}
            type="text"
            placeholder={currentValue}
            onChange={e => updateNewValue(e.target.value)}
            onKeyDown={onKeyDownValidation && onKeyDownValidation}
          />
          {optionButtonText && (
            <OptionButton
              text={optionButtonText}
              setter={optionButtonUpdateNewValue}
              selected={optionButtonNewValue}
              width={WIDTH384}
              clearError={() => setErrorMessage("")}
            />
          )}
          <div className={errorMessage ? "text-red-600 mb-4" : "hidden"}>
            {errorMessage}
          </div>
          <Button
            className={`mb-6 mt-5 w-36 text-2xl btn-green ${
              loading ? "opacity-50" : ""
            }`}
            disabled={loading}
            onClick={() => {
              onSubmit();
            }}
          >
            Submit
          </Button>
        </div>
      ) : (
        <SuccessMessage
          mainMessage={successMainMessage}
          subMessage={successSubMessage}
        />
      )}
    </div>
  );
};

export default UpdateUserDetailsModal;
